import { useState, useCallback } from 'react';
import Slider from "react-slick";
import { useTranslation } from 'react-i18next';

import { images } from '../../constants';
import './Hero.scss';

const Hero = () => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  // Only load first video initially, lazy load others on slide change
  const [loadedVideos, setLoadedVideos] = useState([0]);

  const handleBeforeChange = useCallback((_current, next) => {
    setLoadedVideos(prev => {
      if (!prev.includes(next)) {
        return [...prev, next];
      }
      return prev;
    });
  }, []);

  const settings = {
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 14000,
    beforeChange: handleBeforeChange,
    lazyLoad: 'ondemand',
  };

  const videos = isArabic
    ? [images.landing1AR, images.landing2AR, images.landing3AR]
    : [images.landing1, images.landing2, images.landing3];

  return (
    <>
      <div className="container2 hero-container">
        <div className="LandingVid">
          <Slider {...settings}>
            {videos.map((video, index) => (
              <div key={index} className="video-slide">
                {loadedVideos.includes(index) ? (
                  <video
                    src={video}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload={index === 0 ? "auto" : "none"}
                  />
                ) : (
                  <div className="video-placeholder" />
                )}
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Hero;
